import styled, { css }  from 'vue-styled-components'


const DesignProps = {
  customFonts: Array,
};
const Design = styled("div", DesignProps)`
/*! v0.1.16 */
.device,
.device::before,
.device::after,
.device *,
.device *::before,
.device *::after {
  box-sizing: border-box;
  display: block;
}

.device {
  position: relative;
  transform: scale(1);
  z-index: 1;
}

.device .device-frame {
  z-index: 1;
}

.device .device-content {
  background-color: #fff;
  background-position: center center;
  background-size: cover;
  object-fit: cover;
  position: relative;
}

.device-iphone-x {
  height: 868px;
  width: 431px;
}

.device-iphone-x .device-frame {
  background: #222;
  border-radius: 68px;
  box-shadow: inset 0 0 2px 2px #c8cacb, inset 0 0 0 7px #e2e3e4;
  height: 868px;
  padding: 28px;
  width: 431px;
}

.device-iphone-x .device-content {
  border-radius: 40px;
  height: 812px;
  width: 375px;
}

.device-iphone-x .device-stripe::after,
.device-iphone-x .device-stripe::before {
  pointer-events: none;
  border: solid rgba(51, 51, 51, 0.25);
  border-width: 0 7px;
  content: "";
  height: 7px;
  left: 0;
  position: absolute;
  width: 100%;
  z-index: 9;
}

.device-iphone-x .device-stripe::after {
  top: 85px;
}

.device-iphone-x .device-stripe::before {
  bottom: 85px;
}

.device-iphone-x .device-header {
  background: #222;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  height: 30px;
  left: 50%;
  margin-left: -102px;
  position: absolute;
  top: 28px;
  width: 204px;
}

.device-iphone-x .device-header::after,
.device-iphone-x .device-header::before {
  content: "";
  height: 10px;
  position: absolute;
  top: 0;
  width: 10px;
}

.device-iphone-x .device-header::after {
  background: radial-gradient(
    circle at bottom left,
    transparent 0,
    transparent 75%,
    #222 75%,
    #222 100%
  );
  left: -10px;
}

.device-iphone-x .device-header::before {
  background: radial-gradient(
    circle at bottom right,
    transparent 0,
    transparent 75%,
    #222 75%,
    #222 100%
  );
  right: -10px;
}

.device-iphone-x .device-sensors::after,
.device-iphone-x .device-sensors::before {
  content: "";
  position: absolute;
}

.device-iphone-x .device-sensors::after {
  background: #444;
  border-radius: 3px;
  height: 6px;
  left: 50%;
  margin-left: -25px;
  top: 32px;
  width: 50px;
}

.device-iphone-x .device-sensors::before {
  background: #444;
  border-radius: 50%;
  height: 14px;
  left: 50%;
  margin-left: 40px;
  top: 28px;
  width: 14px;
}

.device-iphone-x .device-btns {
  background: #c8cacb;
  height: 32px;
  left: -3px;
  position: absolute;
  top: 115px;
  width: 3px;
}

.device-iphone-x .device-btns::after,
.device-iphone-x .device-btns::before {
  background: #c8cacb;
  content: "";
  height: 62px;
  left: 0;
  position: absolute;
  width: 3px;
}

.device-iphone-x .device-btns::after {
  top: 60px;
}

.device-iphone-x .device-btns::before {
  top: 140px;
}

.device-iphone-x .device-power {
  background: #c8cacb;
  height: 100px;
  position: absolute;
  right: -3px;
  top: 200px;
  width: 3px;
}
.device-ipad-pro {
  /*height: 804px;*/
  height: 1148px;
  /*width: 560px;*/
  width: 818px;
}
.device-ipad-pro .device-frame {
  background: #fff;
  border-radius: 38px;
  box-shadow: inset 0 0 0 2px #c8cacb, inset 0 0 0 6px #e2e3e4;
  /*height: 804px;*/
  height: 1148px;
  padding: 62px 25px;
  /*width: 560px;*/
  width: 818px;
}

.device-ipad-pro .device-content {
  border: 2px solid #222;
  border-radius: 2px;
  height: 680px;
  width: 510px;
}

.device-ipad-pro .device-header {
  border: 2px solid #c8cacb;
  border-radius: 50%;
  bottom: 17px;
  height: 34px;
  left: 50%;
  margin-left: -17px;
  position: absolute;
  width: 34px;
}

.device-ipad-pro .device-sensors {
  background: #666;
  border-radius: 50%;
  height: 10px;
  left: 50%;
  margin-left: -5px;
  margin-top: -5px;
  position: absolute;
  top: 34px;
  width: 10px;
}

.device-ipad-pro.device-gold .device-frame {
  box-shadow: inset 0 0 0 2px #e4b08a, inset 0 0 0 6px #f7e8dd;
}

.device-ipad-pro.device-gold .device-header {
  border-color: #e4b08a;
}

.device-ipad-pro.device-rosegold .device-frame {
  box-shadow: inset 0 0 0 2px #f6a69a, inset 0 0 0 6px #facfc9;
}

.device-ipad-pro.device-rosegold .device-header {
  border-color: #f6a69a;
}

.device-ipad-pro.device-spacegray .device-frame {
  background: #222;
  box-shadow: inset 0 0 0 2px #818187, inset 0 0 0 6px #9b9ba0;
}
.device-ipad-pro.device-spacegray .device-frame #viewport {
  background: #ffffff;
}
.device.device-iphone-x #viewport {
  background: #ffffff;
}
.device-ipad-pro.device-spacegray .device-header {
  border-color: #818187;
}
.device-desktop {
  /*height: 804px;*/
  /* height: 1148px; */
  /*width: 560px;*/
  /* width: 818px; */
}

.device-desktop .device-frame {
  /* background: #fff; */
  /* box-shadow: 0 0 4px rgba(0,0,0,0.1),0 1px 2px rgba(0,0,0,0.1);; */
  iframe {

  /* border-radius: 5px; */
  }
  /*height: 804px;*/
  /* height: 1148px; */
  /* padding: 62px 25px; */
  /* padding: 15px; */
  /* padding: 15px 15px 0 15px; */
  /* overflow: hidden;
  overflow-x: scroll; */
  /*width: 560px;*/
  /* width: 818px; */
}

.device-desktop .device-content {
  border: 2px solid #222;
  border-radius: 2px;
  /* height: 680px;
  width: 510px; */
}

.device-desktop .device-header {
  border: 2px solid #c8cacb;
  border-radius: 50%;
  bottom: 17px;
  height: 34px;
  left: 50%;
  margin-left: -17px;
  position: absolute;
  width: 34px;
}

.device-desktop .device-sensors {
  background: #666;
  border-radius: 50%;
  height: 10px;
  left: 50%;
  margin-left: -5px;
  margin-top: -5px;
  position: absolute;
  top: 34px;
  width: 10px;
}

${({ customFonts }) => getCustomFonts(customFonts)}
`
const getCustomFonts = (customFonts) => {
  return css`
    ${Object.entries(customFonts).map((font) => `
    @font-face {
      font-family: ${font[1].name};
      src: url(${font[1].url});
    };
    `).join('')}  
  `
}

const SkeletonProps = {
  screenSize: String,
};
const Skeleton = styled("div", SkeletonProps)`
  background-color: white;

  width: 100%;
  ${({ screenSize }) => (screenSize == "Mobile" ? "border-radius: 40px;" : "")}
  display: block;
  margin: 0 auto;
  border: 0px;
  padding: 0;
  height: 100%;
  vertical-align: bottom;
  overflow-x: hidden;
  min-width: 300px;
  .b-skeleton {
    background-color: rgb(245 246 247);
  }
`;
export {
  Design,
  Skeleton,
}